import React from "react";
import styled from "styled-components";
import theme from "theme";
import { sectionIds, trustBand } from "content/site";
import {
	Container,
	Section,
	SectionTitle,
	SectionLead,
	MarketingCard,
} from "components/marketing/primitives";

const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
	gap: 1.25rem;
`;

const PointTitle = styled.h3`
	font-family: ${theme.fontFamily.sans};
	font-size: 1rem;
	font-weight: 700;
	margin: 0 0 0.45rem;
	color: ${theme.color.dark};
	letter-spacing: -0.02em;
`;

const PointBody = styled.p`
	font-family: ${theme.fontFamily.sans};
	font-size: 0.875rem;
	color: ${theme.color.greyD2};
	margin: 0;
	line-height: 1.55;
	flex: 1;
`;

export default function TrustBand() {
	return (
		<Section id={sectionIds.trust} aria-labelledby="trust-heading">
			<Container>
				<SectionTitle id="trust-heading">{trustBand.title}</SectionTitle>
				<SectionLead>{trustBand.lead}</SectionLead>
				<Grid>
					{trustBand.points.map((p) => (
						<MarketingCard key={p.title}>
							<PointTitle>{p.title}</PointTitle>
							<PointBody>{p.body}</PointBody>
						</MarketingCard>
					))}
				</Grid>
			</Container>
		</Section>
	);
}
